const percentOf = (completed: number, total: number) =>
  total > 0 ? ` (${Math.round((completed / total) * 100)}%)` : "";

const translations = {
  PageTitle: "LiDAR Upload Dashboard",
  AddProject: "Add project",
  RemoveProject: "Remove project",
  MergeAndImport: "Merge & Import LiDAR-tiles",
  MergeDialogTitle: (projectName: string) => `Merge & Import "${projectName}"`,
  NothingToMerge:
    "No files have been uploaded yet. Upload files before starting the merge.",
  ClearanceSystemLabel: "Clearance system",
  ClearanceSystemRequired: "Select a Clearance System to use for analysis",
  CfgTemplateLabel: "CFG template",
  CfgTemplateRequired: "Select a CFG template to use for analysis",
  Cancel: "Cancel",
  StartMerge: "Proceed",
  MergeStarted: "LiDAR merge pipeline started successfully.",
  MergeFailed: (errorCode: string) =>
    `Failed to start the LiDAR merge pipeline. Please try again. (${errorCode})`,
  MergeOptionsFailed: "Failed to load clearance systems and CFG templates",
  NoProjectOptions: "No projects",
  Refresh: "Refresh",
  Loading: "Loading…",
  LoadFailed: "Failed to load LiDAR upload status",
  NoProjectsSelected: "Add projects to see their LiDAR upload status",
  ColumnProject: "Project",
  ColumnUploadedFiles: "Files",
  ColumnScenes: "Scenes",
  ColumnStatus: "Status",
  ColumnStateReached: "Since",
  JustNow: "just now",
  UpdatedAt: (relativeTime: string) => `Updated ${relativeTime}`,
  StalledFor: (days: number) => `No progress for ${days} days`,
  SummaryCount: (count: number, label: string) => `${count} ${label}`,
  NoGroup: "No group",
  GroupProjectCount: (projectCount: number) =>
    `${projectCount} ${projectCount === 1 ? "project" : "projects"}`,
  StatusNone: "None",
  StatusAirpelagoUpload: "AP Upload",
  AirpelagoBucketFiles: (fileCount: number, size: string) =>
    `${fileCount} files (${size}) in Airpelago's upload bucket`,
  StatusRawUploaded: "Raw Uploaded",
  StatusMerged: "Merged",
  StatusDisplayed: "Displayed",
  StatusAnalysed: "Analysed",
  ReachedAt: (time: string) => `Reached ${time}`,
  NotReached: "Not reached",
  NoTimeRecorded: "No time recorded",
  NoTimestamp: "–",
  UploadedProgress: (uploaded: number) => `${uploaded} files uploaded`,
  RawBucketFiles: (fileCount: number, size: string) =>
    `${fileCount} files (${size}) in the raw bucket`,
  MergeNotTracked: "Merging isn't tracked for files outside the uploader",
  S3Source: "S3",
  S3SourceTooltip: "No uploader records, counted from the raw LiDAR bucket",
  MergedProgress: (merged: number, total: number) =>
    `${merged} / ${total} files merged${percentOf(merged, total)}`,
  DisplayedProgress: (displayed: number, total: number) =>
    `${displayed} / ${total} scenes with zones${percentOf(displayed, total)}`,
  AnalysedProgress: (analysed: number, total: number) =>
    `${analysed} / ${total} scenes analysed${percentOf(analysed, total)}`,
};

export default translations;
